// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"d8127698d89ac01f","5474":"32dff511642ab542"}[chunkId] + ".css";
};